import React, { useState, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './slide-form.styles'
import { Formik } from 'formik'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import * as Yup from 'yup'
import { ModalContent } from 'pobble-components/dist/modal'
import FormRow from '../../../common/form-elements/form-row/form-row'
import {
  StickyEditor,
  EditorState,
  Controls,
  createStateFromHtml,
  stateToHTML
} from '../../../editor'

const TITLE_MAX_LENGTH = 50
const DESCRIPTION_MAX_LENGTH = 400

const SlideForm = ({ classes, onSubmit, initialValues, footer }) => {
  const [editorState, setEditorState] = useState(
    !initialValues.description
      ? EditorState.createEmpty()
      : createStateFromHtml(initialValues.description)
  )
  return (
    <Formik
      onSubmit={values =>
        onSubmit({
          ...values,
          description: editorState.getCurrentContent().getPlainText(),
          descriptionHTML: stateToHTML(editorState)
        })
      }
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        title: Yup.string().required('Title can not be blank'),
        description: Yup.string().required('Description can not be blank')
      })}>
      {formikProps => {
        const {
          handleSubmit,
          handleBlur,
          handleChange,
          values,
          errors,
          touched,
          setFieldValue
        } = formikProps
        return (
          <form onSubmit={handleSubmit} className="metrics__slide-form">
            <ModalContent legacy>
              <FormRow first>
                <FormLabel small htmlFor="exemplarTitle" spaceBetween>
                  Title
                  <CharactersCount
                    value={values.title}
                    max={TITLE_MAX_LENGTH}
                  />
                </FormLabel>
                <FormInput
                  validationError={touched.title && errors.title}
                  placeholder="eg. Synonyms video"
                  required
                  name="title"
                  id="exemplarTitle"
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={TITLE_MAX_LENGTH}
                />
              </FormRow>
              <FormRow>
                <FormLabel small htmlFor="exemplarDescription" spaceBetween>
                  Description
                  <CharactersCount
                    value={values.description}
                    max={DESCRIPTION_MAX_LENGTH}
                  />
                </FormLabel>
                <StickyEditor
                  maxLength={DESCRIPTION_MAX_LENGTH}
                  error={!!errors.description}
                  placeholder="Exemplar description"
                  controls={
                    <Fragment>
                      <Controls.Bold />
                      <Controls.Italic />
                      <Controls.Underline />
                      <Controls.Separator />
                      <Controls.UnorderedList />
                      <Controls.OrderedList />
                    </Fragment>
                  }
                  editorState={editorState}
                  onChange={newState => {
                    const plainText = newState
                      .getCurrentContent()
                      .getPlainText()
                    setFieldValue('description', plainText)
                    setEditorState(newState)
                  }}
                />
              </FormRow>
            </ModalContent>
            {footer(formikProps)}
          </form>
        )
      }}
    </Formik>
  )
}

export default injectSheet(styles)(SlideForm)
